// Typelizer digest bca5deba97b5326f1f67b8dd887a53eb
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /accountant */
  accountantRoot: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/accountant', {}, options),
    method: 'get',
  }),

  /** GET /bank_statement_uploads */
  bankStatementUploads: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/bank_statement_uploads', {}, options),
    method: 'get',
  }),
}
